import Sheet from 'components/utils/Sheet'
import devOnlyCss, { InvalidElementStyle } from 'lib/styles/devOnlyCss'
import styled from 'styled-components'

// This is only in a separate file so the CSS below can be used without creating circular dependencies
export const AccommodationIndividualRoomTileGridBase = styled(Sheet)``

export const accommodationIndividualRoomTileGridChildEnforcer = devOnlyCss`
  &:not(${AccommodationIndividualRoomTileGridBase} > &) { ${InvalidElementStyle('This element must be a direct child of <AccommodationIndividualRoomTile>')} }
`
